import { apiResolverApi } from "@gymflow/api";
import { gymflowApi } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";
import { api } from "libs/api/src/lib/apiv2/api";
import { ReactNode, useEffect } from "react";
import { useParams } from "react-router";

import { LoadingPortal } from "../../components/pages";
import { GymflowModelsContext } from "../../store";
import { rememberMeRouteIdKey } from "../authentication/RememberMeRouteIdKey";
import { ApiResolverContext } from "./ApiResolverContext";

export function ApiResolverProvider({ children }: { children: ReactNode }) {
  const { brand, company, location } = useParams<{
    brand: string;
    company: string;
    location: string;
  }>();
  const routeId = `${brand}/${company}/${location}`;
  if (window.location.href.includes(`${routeId}/staff`)) {
    localStorage.setItem(rememberMeRouteIdKey, routeId);
  }
  const {
    data: clubMetaData,
    isLoading,
    isSuccess,
  } = useQuery({
    queryKey: ["clubMetaData", routeId],
    queryFn: async () => apiResolverApi.getServerByRouteId(routeId!),
  });

  useEffect(() => {
    if (isSuccess) {
      api.defaults.baseURL = clubMetaData.urls.api;
    }
  }, [isSuccess, clubMetaData]);

  if (isLoading) {
    return <LoadingPortal message="Contacting server..." />;
  }

  if (!clubMetaData) {
    return <LoadingPortal message="Error contacting server" />;
  }

  return (
    <ApiResolverContext.Provider value={clubMetaData}>
      <GymflowModelsContext.Provider
        value={{
          api: gymflowApi({
            apiUrl: clubMetaData.urls.api,
            clubId: clubMetaData.clubId,
            axiosInstance: api,
          }),
        }}
      >
        {children}
      </GymflowModelsContext.Provider>
    </ApiResolverContext.Provider>
  );
}
